import { inresiHttpService } from "utils/http";

import {
  type SaveFiltersPayload,
  type SaveFiltersResponse,
  SaveFiltersResponseSchema,
} from "../schemas";

export type { SaveFiltersPayload, SaveFiltersResponse };

export async function saveFilters(
  slug: string,
  payload: SaveFiltersPayload
): Promise<SaveFiltersResponse["data"]> {
  const res = await inresiHttpService.post<SaveFiltersResponse>(
    `embed/${slug}/save_filters`,
    payload,
    { schema: SaveFiltersResponseSchema }
  );
  return res.data;
}
